import { FloorplanPlacementData } from './floorplan'
import Insight, { Data as InsightData } from './insight'

export interface Data extends InsightData, FloorplanPlacementData {
  id: number
  workspace_type_id: number
}

class InsightWorkspace extends Insight<Data> {
  get id() {
    return this.data?.id
  }

  get name() {
    return this.data?.x
  }

  get workspaceTypeId() {
    return this.data.workspace_type_id
  }

  get floorplanElementId() {
    return this.data.element_id
  }

  get floorplanPosition() {
    return this.data.position
  }

  get floorplanIsPlaced() {
    const position = this.data.position
    if (!position) return false
    const { x, y, rotation } = position
    return Number.isFinite(x) && Number.isFinite(y) && Number.isFinite(rotation)
  }
}

export default InsightWorkspace
